import React, { useCallback } from "react";
import '../../CSS/Estilo.css';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';

export default function FilesList({ files, onClear, uploadComplete }){

    function FilesListItem({ name, id, onClear, uploadComplete }){
        const handleClear = useCallback(() => {
          onClear(id);
        }, []);
    
            return (
            <li className={'files_list_item'}>
                    <span className={'files_list_item_name'}>{name}</span>
                <input id={'descripcion'+id}
                       type={"text"}
                       placeholder={"Descripción del contenido"}
                       className={"tbDescripcion"}>
                </input>
                <div className={"divCheckBox"}>
                    {!uploadComplete ? (
                        <span
                            className={'files_list_item_clear'}
                            role="button"
                            aria-label="remove file"
                            onClick={handleClear}
                            style={{background:'red'}}
                        >
                        <ClearIcon sx={{fontSize:'2rem'}} />
                    </span>
                    ) : (
                        <span role="img" className={'file_list_item_check'}>
                        <CheckIcon sx={{fontSize:'2rem'}}/>
                    </span>
                    )}
                    <label className={'files_list_item_label'}> Compartir con todos </label>
                    <input  id={'compartido'+id}
                            type={"checkbox"}
                            className={"files_list_item_checkbox"}/>
                    <label className={'files_list_item_label'}> Compartir con: </label>
                    <input  id={'compartido'+id}
                            type={"text"}
                            className={"files_list_item_share_input"}
                            placeholder={"Lista de usuarios separados con ; "}/>
                </div>
            </li>
            );}

  return (
    <ul className={'files_list'} id={'listaFicheros'}>
      {files.map(({ file, id }) => (
        <FilesListItem
          name={file.name}
          key={id}
          id={id}
          onClear={onClear}
          uploadComplete={uploadComplete}
        />
      ))}
    </ul>
  );
};
